import React, { useMemo, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { Button } from "reactstrap"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { getAwardsList } from "../../../redux/actions/awards"

const AwardsList = () => {
  document.title = "PULA Awards List"

  const history = useNavigate()
  const dispatch = useDispatch()
  const awardsListState = useSelector(state => state.awards.awardsList)
  const [awardsList, setAwardsList] = useState([])

  // Fetch Awards List API
  useEffect(() => {
    dispatch(getAwardsList({ offset: 1 }))
  }, [])

  useEffect(() => {
    if (awardsListState && awardsListState.length > 0) {
      const formattedData = awardsListState.map((item, index) => ({
        ...item,
        id: item.enc_award_id,
        title: item.title || "-",
        date: new Date(item.award_date).toLocaleDateString(),
        status: item.status || "-",
      }))

      setAwardsList(formattedData)
    }
  }, [awardsListState])

  const columns = useMemo(
    () => [
      {
        header: "Season",
        accessorKey: "title",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Date",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status_label",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const status = info.getValue()
          return (
            <span
              className={`badge ${
                status === "Active" ? "bg-success" : "bg-danger"
              }`}
            >
              {status}
            </span>
          )
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() => history(`/awards/nominations?id=${row.id}`)}
                title="View Nominations"
              >
                View Nominations
              </button>
              {/* <button
                className="btn btn-sm btn-success me-2"
                onClick={() => history(`/bazaar-registration?id=${row.id}`)}
                title="Book Stall"
              >
                Book Stall
              </button>
              <button
                className="btn btn-sm btn-info"
                onClick={() => history(`/view-booking-list?id=${row.id}`)}
                title="View Booking List"
              >
                View Payments
              </button>
              <button
                className="btn btn-sm btn-danger ms-2"
                onClick={() => history(`/edit-bazaar`)}
                title="Edit Bazaar"
              >
                Edit Bazaar
              </button> */}
            </div>
          )
        },
      },
    ],
    [history]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
          {/* <Button
            color="primary"
            onClick={() => (window.location.href = "/add-bazaar")}
          >
            Add Award Form
          </Button> */}
        </div>

        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={awardsList || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default AwardsList
